<template>
  <!-- Mobile only: footer for the registration pages with route meta `mobileFooter`. -->
  <footer class="regMobileFooter">
    <div class="regMobileFooterTop">
      <router-link :to="{ name: 'homepage' }">
        <img src="@/assets/imgs/web/weblogo.png" alt="AlUla Logo" class="regMobileFooterLogo">
      </router-link>
      <div class="regMobileFooterSocials">
        <a v-for="social in socials" :key="social.link" :href="social.link" target="_blank" class="regMobileFooterSocial">
          <img :src="social.image" alt="">
        </a>
      </div>
    </div>
    <div class="regMobileFooterLinks">
      <p class="regMobileFooterLinksTitle">Quick Links</p>
      <nav class="regMobileFooterNav">
        <router-link v-for="el in link_list" :key="el.navigation_route" :to="{ path: el.navigation_route }">{{ el.title_en }}</router-link>
      </nav>
    </div>
    <div class="regMobileFooterCopyright" v-html="copyright"></div>
  </footer>
</template>

<script>
// Same CMS content as the website footer (components/Common/Footer.vue).
const SOCIAL_CARD_SLUGS = ['card-footer-4', 'card-footer-5', 'card-footer-6', 'card-footer-7'];

export default {
  name: 'RegMobileFooter',
  data() {
    return {
      footer_data: {},
      link_list: [],
    };
  },
  computed: {
    socials() {
      return SOCIAL_CARD_SLUGS
        .map(slug => this.footer_data?.elements?.find(e => e.slug == slug))
        .map(card => ({ image: card?.sub_elements[0]?.image, link: card?.sub_elements[1]?.link }))
        .filter(social => social.image && social.link);
    },
    copyright() {
      return this.footer_data?.elements?.find(e => e.slug == 'text-footer-3')?.content_en;
    },
  },
  mounted() {
    this.axios.post(this.$store.state.baseApiUrl + 'web-content/get-section-by-slug', { section_slug: 'footer' })
      .then(response => {
        this.footer_data = response.data.data;
      })
      .catch(error => {
        console.error('Error fetching footer data:', error);
      });
    this.axios.get(this.$store.state.baseApiUrl + 'web-content/get-navigation')
      .then(response => {
        this.link_list = response.data.data;
      })
      .catch(error => {
        console.error('Error fetching navigation:', error);
      });
  },
};
</script>

<style scoped>
.regMobileFooter{
  display: none;
}
@media all and (max-width:768px) {
  .regMobileFooter{
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding: 20px;
    background: var(--brown-dark);
    text-align: left;
  }
}
.regMobileFooterTop{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.regMobileFooterLogo{
  display: block;
  height: 44px;
  width: auto;
}
.regMobileFooterSocials{
  display: flex;
  gap: 12px;
}
.regMobileFooterSocial{
  display: block;
  width: 32px;
  height: 32px;
  border-radius: 16px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.1);
}
/* The CMS icons are drawn on a circle in the footer's own brown; "lighten" lets the
   translucent circle behind them show through while keeping the light glyph. */
.regMobileFooterSocial img{
  display: block;
  width: 100%;
  height: 100%;
  mix-blend-mode: lighten;
}
.regMobileFooterLinks{
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-top: 24px;
  border-top: 1px solid rgba(255, 255, 255, 0.125);
}
.regMobileFooterLinksTitle{
  color: var(--white);
  font-size: 13px;
  font-weight: 600;
  line-height: 16px;
}
.regMobileFooterNav{
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}
.regMobileFooterNav a{
  color: var(--beige-light);
  font-size: 12px;
  line-height: 15px;
  text-decoration: none;
}
.regMobileFooterCopyright{
  color: rgba(212, 213, 200, 0.5);
  font-size: 11px;
  line-height: 13px;
}
</style>
